/* INTEGY V431 — card metadata hygiene, dark-theme action hierarchy,
   collection-specific filter cleanup, and one-shot filtered-state release. */
(function () {
  'use strict';
  if (window.IntegyV431ConversionStability) return;

  var root = document.documentElement;
  var genericFitment = /^(?:all integy hop-?up parts|all products|products|bargain outlet center|one-of-a-kind,? open box,? scratch\s*&\s*dent|boats|parts for more rc vehicles|integy hop-ups for more rc vehicles)$/i;
  var vehicleFilterAllow = {
    'rtr':1,'artr':1,'kit':1,'2wd':1,'4wd':1,'6x6':1,'8x8':1,
    '1-5':1,'1-6':1,'1-7':1,'1-8':1,'1-10':1,'1-12':1,'1-14':1,'1-16':1,'1-18':1,'1-24':1,
    'buggy':1,'truggy':1,'short-course':1,'monster-truck':1,'crawler':1,'rock-crawler':1,
    'drift':1,'touring':1,'touring-car':1,'f1':1,'m-chassis':1,'micro-mini':1,
    'truck':1,'semi-truck':1,'on-road':1,'off-road':1,'all-terrain':1,
    'electric':1,'nitro':1,'gas':1,'brushed':1,'brushless':1
  };

  function qsa(selector, scope) {
    try { return Array.prototype.slice.call((scope || document).querySelectorAll(selector)); }
    catch (error) { return []; }
  }
  function qs(selector, scope) {
    try { return (scope || document).querySelector(selector); }
    catch (error) { return null; }
  }
  function clean(value) { return String(value == null ? '' : value).replace(/\s+/g, ' ').trim(); }
  function handleize(value) {
    value = clean(value).toLowerCase();
    try { value = value.normalize('NFKD').replace(/[\u0300-\u036f]/g, ''); } catch (error) {}
    return value.replace(/&/g, ' and ').replace(/[’']/g, '').replace(/[^a-z0-9]+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
  }
  function collectionHandle() {
    var match = String(location.pathname || '').match(/^\/collections\/([^/?#]+)/i);
    return match ? handleize(decodeURIComponent(match[1])) : '';
  }
  function normalizedType(value) {
    var type = clean(value).replace(/^Type:\s*/i, '');
    if (!type) return '';
    if (/hex\s+nut\s+wrench/i.test(type)) return 'Hex Nut Wrench';
    if (/turnbuckle\s+wrench/i.test(type)) return 'Turnbuckle Wrench';
    if (/48\s*[- ]?pitch\s+pinion/i.test(type)) return '48-Pitch Pinion Gear';
    if (/steering\s+tie\s+rod/i.test(type)) return 'Steering Tie Rod';
    if (/suspension\s+(?:link|linkage)|linkage\s+(?:set|rod)/i.test(type)) return 'Suspension Linkage';
    if (/universal\s+drive\s+shaft|\bdrive\s+shaft/i.test(type)) return 'Drive Shaft';
    if (/\bpinion\s+gear/i.test(type)) return 'Pinion Gear';
    if (/\bspur\s+gear/i.test(type)) return 'Spur Gear';
    if (/gearbox\s+housing/i.test(type)) return 'Gearbox Housing';
    if (/engine\s+mount/i.test(type)) return 'Engine Mount';
    if (/roll\s+cage/i.test(type)) return 'Roll Cage';
    if (/wheelie\s+bar/i.test(type)) return 'Wheelie Bar';
    if (/body\s+post/i.test(type)) return 'Body Post';
    if (/scale\s+interior|\binterior\b/i.test(type)) return 'Scale Interior';
    if (/suspension\s+pin|hinge\s+pin/i.test(type)) return 'Suspension Pin';
    if (/arm\s+brace/i.test(type)) return 'Suspension Brace';
    if (/chassis\s+brace|^brace$/i.test(type)) return 'Chassis Brace';
    if (/ball\s+(?:end|link)/i.test(type)) return 'Ball End / Link';
    if (/spring\s+retainer/i.test(type)) return 'Spring Retainer';
    if (/^spring$/i.test(type)) return 'Spring';
    if (/o-ring/i.test(type)) return 'O-Ring';
    if (/e-clip/i.test(type)) return 'E-Clip';
    if (/performance\s+shock\s+set|\bshock\s+set/i.test(type)) return 'Shock Set';
    if (/servo\s+mount/i.test(type)) return 'Servo Mount';
    if (/servo\s+horn/i.test(type)) return 'Servo Horn';
    if (/servo\s+saver/i.test(type)) return 'Servo Saver';
    if (/setup\s+station.*adapter|adapter.*setup\s+station/i.test(type)) return 'Setup Station Adapter';
    if (/workstation|workbench\s+organizer|pit\s+(?:area\s+)?(?:mat|organizer)/i.test(type)) return 'Pit Workstation';
    if (/tool\s+(?:bag|case)/i.test(type)) return 'Tool Bag / Case';
    if (/^tie\s+rod\b/i.test(type)) return 'Tie Rod';
    if (/radio\s+system/i.test(type)) return 'Radio System';
    if (/receiver\s+box/i.test(type)) return 'Receiver Box';
    if (/\breceiver\b/i.test(type) && /radio\s+controllers?|tx\s+receivers?/i.test(type)) return 'Receiver';
    type = type.split(/\s+1\/\d+|\s+for\s+|\s*\|\s*/i)[0];
    var words = type.split(/\s+/), output = [];
    words.forEach(function (word) {
      if (!output.length || output[output.length - 1].toLowerCase() !== word.toLowerCase()) output.push(word);
    });
    return clean(output.join(' ')).slice(0, 64);
  }

  function cleanCard(card) {
    var soldOutText = clean((qs('.productitem--badge,.productitem__badge,.productitem--stock-level,.productitem__stock-level', card) || {}).textContent);
    card.classList.toggle('integy-v431-card-soldout', /sold\s*out|out\s*of\s*stock/i.test(soldOutText));
    qsa('[data-integy-v389-sale-summary],.integy-v389-card-sale-summary', card).forEach(function (node) { node.remove(); });
    qsa('.productitem__unit-price,[data-unit-price]', card).forEach(function (node) {
      var text = clean(node.textContent);
      if (!text || text === '| /' || text === '| / unit') node.remove();
    });
    qsa('.integy-v426-card-fits', card).forEach(function (node) {
      var text = clean(node.textContent).replace(/^Fits:\s*/i, '');
      if (!text || genericFitment.test(text)) node.remove();
    });
    // V725: preserve the catalog Type rendered by the card owner.
  }
  function cleanCards(scope) {
    qsa('[data-product-item],.productgrid--item,.integy-v426-search-card', scope || document).forEach(cleanCard);
  }
  function markModelChips(scope) {
    qsa('[data-integy-static-model-filter-row]', scope || document).forEach(function (row) {
      row.classList.add('integy-v426-filter-chip', 'integy-v427-filter-chip', 'integy-v428-filter-chip', 'integy-v429-filter-chip', 'integy-v430-filter-chip', 'integy-v431-filter-chip');
      row.setAttribute('data-integy-v426-filter-group', 'vehicle_model');
      row.setAttribute('aria-pressed', row.getAttribute('aria-checked') === 'true' ? 'true' : 'false');
    });
  }
  function dedupeControls(scope) {
    [
      '[data-productgrid-trigger-filters],.utils-filter-button,.productgrid--sidebar-button',
      '[data-productgrid-trigger-sort-button],.utils-sortby-button'
    ].forEach(function (selector) {
      var groups = [];
      qsa(selector, scope || document).filter(function (element) { return !element.closest('.productgrid--sidebar'); }).forEach(function (element) {
        var parent = element.parentElement;
        var group = groups.filter(function (candidate) { return candidate.parent === parent; })[0];
        if (!group) { group = { parent: parent, controls: [] }; groups.push(group); }
        group.controls.push(element);
      });
      groups.forEach(function (group) {
        group.controls.forEach(function (element, index) {
          if (index > 0) { element.hidden = true; element.setAttribute('aria-hidden', 'true'); }
        });
      });
    });
  }

  function filterHandle(row) {
    var raw = row.getAttribute('data-integy-v307-option') || row.getAttribute('data-integy-v294-option') ||
      row.getAttribute('data-tag-handle') || row.getAttribute('data-handle') || row.getAttribute('data-filter-value') || '';
    if (!raw && row.href) {
      try {
        var url = new URL(row.href, location.origin);
        raw = url.searchParams.get('integy_filter') || url.searchParams.get('integy_vehicle_filter') || '';
        if (!raw) {
          var parts = url.pathname.split('/').filter(Boolean);
          raw = parts[parts.indexOf('collections') + 2] || '';
        }
      } catch (error) {}
    }
    return handleize(raw || clean(row.textContent).replace(/\([\d,]+\)\s*$/, ''));
  }
  function cleanupVehicleFilters(scope) {
    var handle = collectionHandle();
    if (document.body) document.body.setAttribute('data-integy-v430-collection', handle); document.body.setAttribute('data-integy-v431-collection', handle);
    if (handle !== 'cars-trucks') return;
    var sidebar = qs('.productgrid--sidebar,[data-productgrid-sidebar]', scope || document) || document;
    qsa('a[data-integy-v307-option],a[data-integy-v294-filter-row],a[data-integy-v35-tag-filter],a.integy-v27-filter-chip,.filter-item[data-handle],[data-tag-handle]', sidebar).forEach(function (row) {
      var option = filterHandle(row);
      var active = row.getAttribute('aria-checked') === 'true' || row.classList.contains('is-active');
      if (!active && option && !vehicleFilterAllow[option]) row.setAttribute('data-integy-v431-hide-vehicle-filter', 'true');
      else row.removeAttribute('data-integy-v431-hide-vehicle-filter');
    });
  }

  function releasePending() {
    root.classList.remove('integy-v429-filter-pending','integy-v431-filter-pending');
  }
  function watchPendingFilter() {
    if (!root.classList.contains('integy-v429-filter-pending') && !root.classList.contains('integy-v431-filter-pending')) return;
    if (root.classList.contains('integy-v307-filter-resolved')) {
      releasePending(); return;
    }
    var observer = window.MutationObserver ? new MutationObserver(function () {
      if (root.classList.contains('integy-v307-filter-resolved') || root.classList.contains('integy-v307-filter-zero')) {
        observer.disconnect(); releasePending();
      }
    }) : null;
    if (observer) observer.observe(root, { attributes: true, attributeFilter: ['class'] });
    window.setTimeout(function () { if (observer) observer.disconnect(); releasePending(); }, 7000);
  }

  function init(scope) {
    scope = scope || document;
    cleanCards(scope);
    markModelChips(scope);
    dedupeControls(scope);
    cleanupVehicleFilters(scope);
  }
  function observeAddedNodes() {
    if (!window.MutationObserver || !document.body || document.body.dataset.integyV430ConversionObserved === 'true') return;
    document.body.dataset.integyV430ConversionObserved = 'true';
    var scheduled = false;
    new MutationObserver(function (mutations) {
      if (scheduled || !mutations.some(function (mutation) { return mutation.addedNodes && mutation.addedNodes.length; })) return;
      scheduled = true;
      window.requestAnimationFrame(function () { scheduled = false; init(document); });
    }).observe(document.body, { childList: true, subtree: true });
  }
  function boot() { init(document); watchPendingFilter(); observeAddedNodes(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('integy:filter-rendered', function () { init(document); releasePending(); });
  document.addEventListener('integy:v429:filter-rendered', function () { init(document); releasePending(); });
  document.addEventListener('integy:v431:filter-rendered', function () { init(document); releasePending(); });

  window.IntegyV431ConversionStability = {
    init: init,
    cleanCards: cleanCards,
    normalizedType: normalizedType,
    cleanupVehicleFilters: cleanupVehicleFilters,
    releasePending: releasePending
  };
})();
